export class OrderItemApproval {
  LNITEM_SEQ_NUM: string;
  isSubApproved: string;
}
